import React from "react";
import "./Registration_Done.css";
import For_support from "../for-support/For_support";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Registration_Done() {
  return (
    <>
      <section className="Registration_Done">
        <div className="container">
          <div className="headiing_holder">
            <h1>We are glad, that you showed Interest in </h1>
            <h2>Partnering with us</h2>
            
            <Link to={"/schedule-appointment"}>
              <Button className="get_appoinment_btn">
                <FontAwesomeIcon className="me-3" icon={faCalendarDays} /> Get
                Your Appointment Scheduled
              </Button>
            </Link>
          </div>
        </div>

        <For_support />
      </section>
    </>
  );
}

export default Registration_Done;
